import { render } from "./HypoBySurgeryChart.vue?vue&type=template&id=4cf13b5d"
import script from "./HypoBySurgeryChart.vue?vue&type=script&lang=js"
export * from "./HypoBySurgeryChart.vue?vue&type=script&lang=js"

import exportComponent from "/opt/atlassian/pipelines/agent/build/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__